export const getAuctionsWatch = (auctions?: Array<string | number>) => {
  if (!auctions || auctions.length === 0) {
    return {};
  }

  const watchingAuctions: { [key: string]: boolean } = auctions.reduce(
    (res: { [key: string]: boolean }, next: number | string) => (
      (res[next.toString()] = true), res
    ),
    {},
  );
  return watchingAuctions;
};
